import PropTypes from 'prop-types';
import React from 'react';
import {withTranslation} from 'react-i18next';
import BaseDialogContainer from '../../baseContainers/BaseDialogContainer';
import EmployeeService from '../../services/EmployeeService';
import DivContainer from '../../components/DivContainer';
import { classNames } from 'primereact/utils';
import LogEntryService from '../../services/LogEntryService';
import { t } from 'i18next';

class UserRedirectWarningDialog extends BaseDialogContainer {
    constructor(props) {
        super(props, new EmployeeService());
        this.state = {
            logEntry: [],
            showWarning: true,
            employee:{

            }
        };
        this.renderWarning=this.renderWarning.bind(this);
        this.hideWarning=this.hideWarning.bind(this);
        this.logEntryService=new LogEntryService();
    }
    translate(key) {
        const {t} = this.props;
        return t(key);
    }

    initBeforeSetElement() {
    }


    renderWarning(){
        this.setState({
            showWarning: true
        })
    }
    hideWarning(){
        this.setState({
            showWarning: false
        });
    }

    prepareFooter() {
    
        return (
            <div className='footer-dialog-button-container'>
            </div>
        )
    }

    renderFooter() {
       return this.prepareFooter();
    }

    renderHeader() {
        const {t} = this.props;
        return (
            <DivContainer colClass='col-12'>
                <DivContainer colClass='col-12'>
                    <label>
                        {t('userReporting.userRedirectLabel')}
                    </label>
                </DivContainer>
            </DivContainer>
        );
    }

    renderDetails() {
        return (
            <div>
                {this.state.showWarning && (
                    <div style={{ display: 'flex', justifyContent: 'center', marginBottom: '20px' }}>
                        {this.state.showWarning && (
                            <div className={classNames('p-inline', 'p-text-bold', 'p-text-center')} style={{ textAlign: 'justify' }}>
                                <i className={classNames('pi', 'pi-exclamation-triangle', 'p-mr-2')} style={{ fontSize: '1.5rem', color: 'orange' }}></i>
                                <br/>{t('userReporting.redirectDialog.headerMessage')}<br/>
                                <span>{t('userReporting.redirectDialog.message')}</span>
                            </div>
                        )}
                    </div>
                )}
            </div>
        )
    }

}

UserRedirectWarningDialog.defaultProps = {
    visible: false,
    handled: false
};

UserRedirectWarningDialog.propTypes = {
    visible: PropTypes.bool,
    onHide: PropTypes.func,
    afterSave: PropTypes.func,
    elementId: PropTypes.number,
    element: PropTypes.object
};

export default withTranslation()(UserRedirectWarningDialog);
